export default "__VITE_ASSET__B8FBON1B__"